import { render } from "./DocumentFieldExpand.vue?vue&type=template&id=27f0b9dc&scoped=true"
import script from "./DocumentFieldExpand.vue?vue&type=script&lang=js"
export * from "./DocumentFieldExpand.vue?vue&type=script&lang=js"

import "./DocumentFieldExpand.vue?vue&type=style&index=0&id=27f0b9dc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f0b9dc"]])

export default __exports__